// extracted by mini-css-extract-plugin
export default {"pagination":"pagination","active":"active","page-number":"page-number","pageNumber":"page-number"};